<template>
  <div class="impressao-dados-cenario">
    <ImpressaoOperacao :dadosCenario="dadosCenario" />
    <div class="impressao-separador"></div>
    <ImpressaoNcm :dadosCenario="dadosCenario" />
    <div v-show="impressaoMostraRem || impressaoMostraDes" class="impressao-separador"></div>
    <ImpressaoRemDes
      :dadosCenario="dadosCenario"
      :impressaoMostraRem="impressaoMostraRem"
      :impressaoMostraDes="impressaoMostraDes"
    />
  </div>
</template>

<script>
import ImpressaoBloco from "./ImpressaoBloco.vue";
import ImpressaoOperacao from "./ImpressaoOperacao.vue";
import ImpressaoNcm from "./ImpressaoNcm.vue";
import ImpressaoRemDes from "./ImpressaoRemDes.vue";

export default {
  name: "DadoCenarioImpressao",
  props: {
    dadosCenario: Array | Object
  },
  data() {
    return {};
  },
  watch: {
    desabImprimir: {
      deep: true,
      handler() {
        this.$bus.$emit("desativaModal");
      }
    }
  },
  computed: {
    desabImprimir: function() {
      return [
        this.dadosCenario.ufOrigem,
        this.dadosCenario.ufDestino,
        this.dadosCenario.paisOrigem,
        this.dadosCenario.paisDestino,
        this.dadosCenario.tipoDeOperacao,
        this.dadosCenario.origem,
        this.dadosCenario.destinacao,
        this.dadosCenario.ncm,
        this.dadosCenario.ncmDescricao,
        this.dadosCenario.cnaeRem,
        this.dadosCenario.cnaeDes,
        this.dadosCenario.atividadeRem,
        this.dadosCenario.atividadeDes,
        this.dadosCenario.tipoAtividadeRem,
        this.dadosCenario.tipoAtividadeDes,
        this.dadosCenario.regimeRem,
        this.dadosCenario.regimeDes,
        this.dadosCenario.receitaBruta,
        this.dadosCenario.receitaAcumulada,
        this.dadosCenario.receitaMes,
        this.dadosCenario.zfm
      ];
    },
    impressaoMostraRem: function() {
      if (
        this.dadosCenario.cnaeRem ||
        this.dadosCenario.mostraAtividadeRem ||
        this.dadosCenario.mostraTipoAtividadeRem ||
        this.dadosCenario.mostraRegimeRem ||
        !(
          this.dadosCenario.cnpjRem == "" ||
          this.dadosCenario.cnpjRem == undefined ||
          !this.dadosCenario.mostraRem
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    impressaoMostraDes: function() {
      if (
        this.dadosCenario.cnaeDes ||
        this.dadosCenario.mostraRegimeDes ||
        this.dadosCenario.mostraAtividadeDes ||
        this.dadosCenario.mostraTipoAtividadeDes ||
        !(this.dadosCenario.cnpjDes == "" || this.dadosCenario.cnpjDes == undefined)
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  components: { ImpressaoBloco, ImpressaoOperacao, ImpressaoNcm, ImpressaoRemDes }
};
</script>

<style lang="scss" scoped>
.impressao-dados-cenario {
  margin: 20px 25px 20px 25px;
  padding: 20px 40px;
  border: 1px solid var(--preto);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 14px;
    font-weight: bold;
  }
  h4 {
    font-size: 12px;
    font-weight: bold;
  }
}
.impressao-separador {
  margin: 0 0 20px 0;
  width: 100%;
  height: 1px;
  border-top: 1px solid var(--preto);
  align-self: center;
}
</style>
